<template>
    <div>
        <a href="#" @click.prevent.stop="preview()" :class="$spa.css.contextmenu.link">
            <i :class="`${$spa.css.contextmenu.icon} far fa-eye`" />
            {{ $t('actions.see') }}
        </a>
        <a href="#" @click.prevent.stop="edit()" :class="$spa.css.contextmenu.link">
            <i :class="`${$spa.css.contextmenu.icon} far fa-pencil`" />
            {{ $t('actions.edit') }}
        </a>
        <a class="relative" href="#" @click.prevent.stop="destroy()" :class="$spa.css.contextmenu.link">
            <v-spa-loader v-if="deleting"></v-spa-loader>
            <i :class="`${$spa.css.contextmenu.icon} far fa-trash`" />
            {{ $t('actions.delete') }}
        </a>
    </div>
</template>

<script>
    export default {
        props: {
            model: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                deleting: false
            }
        },
        
        methods: {
            close()
            {
                this.$emit('close');
            },

            preview()
            {
                this.model.preview();
                this.close();
            },

            edit()
            {
                this.model.edit();
                this.close();
            },

            async destroy()
            {
                this.deleting = true;
                await this.model.getEndpoint().delete(this.model.uuid);
                this.close();
            },
        }
    }
</script>
